"use client";

import { siteConfig } from "@/config/site";
import { Button } from "@/shared/presentation/components/ui";
import "@/shared/presentation/styles/globals.css";

/**
 * Global error boundary. Renders outside the app tree (replaces root layout),
 * so NextIntlClientProvider is not available. Use hardcoded strings only.
 * @see https://next-intl.dev/docs/environments/server-client-components#missing-context
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body>
        <div className="flex flex-col items-center justify-center min-h-screen px-4 text-center">
          <h1 className="text-6xl font-bold text-destructive">
            Something went wrong
          </h1>
          <h2 className="mt-4 text-2xl font-semibold">An error occurred</h2>
          <p className="mt-2 text-muted-foreground">
            {!siteConfig.isProduction
              ? error.message
              : "We're sorry. Please try again later."}
          </p>
          <Button onClick={reset} className="mt-6">
            Try again
          </Button>
        </div>
      </body>
    </html>
  );
}
